import { AppConfig } from '@aipb/env/util';
import { CustomerConfigEditorEnv } from './customer-config-editor.env';

export class CustomerConfigEditorConfig extends AppConfig<CustomerConfigEditorEnv> {
  get apiUrl(): string {
    // @ts-expect-error foo
    return this.config.apiUrl || undefined;
  }
}
